import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './MainPanelHeader.module.css';

/**
 * MainPanelHeader component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {React.Node} props.children - The children
 * @param {React.Node} props.sortByComponent - The sort by component
 * @param {boolean} props.isSortByActive - Whether the sort by is active
 * @param {boolean} props.listingsAreLoaded - Whether the listings are loaded
 * @param {number} props.resultsCount - The results count
 * @param {boolean} props.searchInProgress - Whether the search is in progress
 * @param {React.Node} props.noResultsInfo - The no results info
 * @returns {JSX.Element}
 */
const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    isSortByActive,
    listingsAreLoaded,
    resultsCount,
    searchInProgress = false,
    noResultsInfo,
    handleListView,
    listingsCounts
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        <div className={css.headerPanel}>
          <div className={css.leftPanle}>
            <div className={css.mainHeading}>Listings</div>
            {/*<div className={css.mainText}>
              <FormattedMessage
                id="MainPanelHeader.ListingPanelHeading"
                values={{ listingsCount: listingsCounts }}
              />
            </div>*/}
            {/*<div className={css.searchResultSummary}>
              <span className={css.resultsFound}>
                {searchInProgress ? (
                  <FormattedMessage id="MainPanelHeader.loadingResults" />
                ) : (
                  <FormattedMessage
                    id="MainPanelHeader.foundResults"
                    values={{ count: resultsCount }}
                  />
                )}
              </span>
            </div>*/}
          </div>
          <div className={css.rightPanel}>
            <button className={css.viewGridBtn} onClick={()=> handleListView(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5.92041 4.5C6.66741 4.50006 7.2915 5.12244 7.2915 5.90527C7.2914 6.68807 6.6677 7.31049 5.92041 7.31055C5.17307 7.31055 4.54942 6.68811 4.54932 5.90527C4.54932 5.12239 5.17331 4.5 5.92041 4.5Z" stroke="#8E8E93"/>
                <path d="M11.9758 4.5C12.7232 4.50006 13.3469 5.12243 13.3469 5.90527C13.3468 6.68795 12.7229 7.31049 11.9758 7.31055C11.2288 7.31055 10.6048 6.68804 10.6047 5.90527C10.6047 5.1224 11.2288 4.5 11.9758 4.5Z" stroke="#8E8E93"/>
                <path d="M18.1292 4.5C18.8766 4.50006 19.5002 5.12232 19.5002 5.90527C19.5002 6.688 18.876 7.31049 18.1292 7.31055C17.3823 7.31055 16.7582 6.68804 16.7581 5.90527C16.7581 5.12231 17.3817 4.5 18.1292 4.5Z" stroke="#8E8E93"/>
                <path d="M5.87109 10.6044C6.61818 10.6044 7.24219 11.2266 7.24219 12.0097C7.24218 12.7926 6.61825 13.4149 5.87109 13.4149C5.12399 13.4148 4.50001 12.7925 4.5 12.0097C4.5 11.2268 5.12406 10.6045 5.87109 10.6044Z" stroke="#8E8E93"/>
                <path d="M11.9268 10.6044C12.6742 10.6045 13.2979 11.2265 13.2979 12.0097C13.2978 12.7926 12.6737 13.4149 11.9268 13.4149C11.1797 13.4149 10.5557 12.7927 10.5557 12.0097L10.5625 11.8651C10.6336 11.1513 11.226 10.6044 11.9268 10.6044Z" stroke="#8E8E93"/>
                <path d="M18.0811 10.6044C18.8281 10.6046 19.4512 11.2266 19.4512 12.0097C19.4512 12.7926 18.8282 13.4147 18.0811 13.4149C17.3333 13.4149 16.709 12.7925 16.709 12.0097L16.7158 11.8651C16.787 11.1515 17.3802 10.6044 18.0811 10.6044Z" stroke="#8E8E93"/>
                <path d="M5.91382 16.6896C6.66089 16.6896 7.28491 17.3118 7.28491 18.0949C7.28481 18.8779 6.66085 19.5002 5.91382 19.5002C5.16683 19.5001 4.54283 18.8773 4.54272 18.0949C4.54272 17.312 5.16672 16.6898 5.91382 16.6896Z" stroke="#8E8E93"/>
                <path d="M11.9697 16.6896C12.7167 16.6896 13.3408 17.3118 13.3408 18.0949C13.3407 18.8779 12.7166 19.5002 11.9697 19.5002C11.2224 19.5001 10.5987 18.8774 10.5986 18.0949C10.5986 17.312 11.2226 16.6898 11.9697 16.6896Z" stroke="#8E8E93"/>
                <path d="M18.1233 16.6896C18.8702 16.6897 19.4944 17.3119 19.4944 18.0949C19.4943 18.8779 18.8705 19.5001 18.1233 19.5002C17.3765 19.5002 16.7523 18.8775 16.7522 18.0949C16.7522 17.3119 17.3763 16.6896 18.1233 16.6896Z" stroke="#8E8E93"/>
              </svg>
            </button>
            <button className={css.viewListBtn} onClick={()=> handleListView(true)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M19.2018 17.8317H8.50271C8.06175 17.8317 7.70435 17.4743 7.70435 17.0333C7.70435 16.5923 8.06175 16.2349 8.50271 16.2349H19.2016C19.6425 16.2349 19.9999 16.5923 19.9999 17.0333C19.9999 17.4743 19.6428 17.8317 19.2018 17.8317Z" fill="#8E8E93"/>
                <path d="M19.2018 12.8203H8.50271C8.06175 12.8203 7.70435 12.4629 7.70435 12.0219C7.70435 11.5809 8.06175 11.2235 8.50271 11.2235H19.2016C19.6425 11.2235 19.9999 11.5809 19.9999 12.0219C20.0002 12.4629 19.6428 12.8203 19.2018 12.8203Z" fill="#8E8E93"/>
                <path d="M19.2018 7.80919H8.50271C8.06175 7.80919 7.70435 7.45179 7.70435 7.01083C7.70435 6.56986 8.06175 6.21246 8.50271 6.21246H19.2016C19.6425 6.21246 19.9999 6.56986 19.9999 7.01083C19.9999 7.45179 19.6428 7.80919 19.2018 7.80919Z" fill="#8E8E93"/>
                <path d="M5.0722 8.14463C5.66436 8.14463 6.1444 7.66459 6.1444 7.07243C6.1444 6.48027 5.66436 6.00023 5.0722 6.00023C4.48004 6.00023 4 6.48027 4 7.07243C4 7.66459 4.48004 8.14463 5.0722 8.14463Z" fill="#8E8E93"/>
                <path d="M5.0722 13.0942C5.66436 13.0942 6.1444 12.6141 6.1444 12.022C6.1444 11.4298 5.66436 10.9498 5.0722 10.9498C4.48004 10.9498 4 11.4298 4 12.022C4 12.6141 4.48004 13.0942 5.0722 13.0942Z" fill="#8E8E93"/>
                <path d="M5.0722 18.0437C5.66436 18.0437 6.1444 17.5637 6.1444 16.9715C6.1444 16.3794 5.66436 15.8993 5.0722 15.8993C4.48004 15.8993 4 16.3794 4 16.9715C4 17.5637 4.48004 18.0437 5.0722 18.0437Z" fill="#8E8E93"/>
              </svg>
            </button>
            {isSortByActive ? (
              <div className={css.sortyByWrapper}>
                {/*<span className={css.sortyBy}>
                  <FormattedMessage id="MainPanelHeader.sortBy" />
                </span>*/}
                {sortByComponent}
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {children}

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

export default MainPanelHeader;
